module.exports = __webpack_public_path__ + "img/bigframe.19b92136.jpg";